<template>
    <div>
        <div
            class="grid grid-cols-1 md:gird-cols-2 xl:grid-cols-2 justify-item py-2 gap-2"
        >
        <template v-for="(item, index) in syncData">
            <el-card shadow="hover" class="h-full" :class="item.color">
            <!-- without date -->
            <div class="flex gap-4 justify-between w-full h-full" v-if="!item.setDate">
                <div class="flex flex-col gap-2">
                <div class="text-lg py-2">{{ item.text }}</div>
                <div class="flex gap-4">
                    <div class="text-xs text-justify" v-html="item.description"></div>
                    <el-button
                    class="h-10"
                    :type="item.buttonAttr.type"
                    :icon="item.buttonAttr.icon"
                    :disabled="item.buttonAttr.disabled"
                    @click="doSync(item)"
                    >
                    {{ item.buttonAttr.text }}
                    </el-button>
                </div>
                </div>
            </div>

            <!-- with date -->
            <div class="flex flex-col gap-4 justify-between w-full h-full" v-else>
                <div class="flex flex-col gap-2">
                <div class="text-lg py-2">{{ item.text }}</div>
                <div class="text-xs text-justify" v-html="item.description"></div>
                </div>
                <div class="flex gap-2">
                <el-date-picker
                    v-model="item.dateRange"
                    type="daterange"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    v-if="item.setDate"
                />
                <el-button
                    class="h-10"
                    :type="item.buttonAttr.type"
                    :icon="item.buttonAttr.icon"
                    :disabled="(
                        item.buttonAttr.disabled
                        || (
                        item.dateRange === null
                        || item.dateRange.length === 0
                        )
                    )"
                    @click="doSync(item)"
                >
                    {{ item.buttonAttr.text }}
                </el-button>
                </div>
            </div>
            </el-card>
        </template>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            syncData: [
                {
                    text: 'DCE Data',
                    url: '/_PopulateMaster/SingleDCEPull',
                    color:
                        'bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-lg',
                    setDate: false,
                    buttonAttr: {
                        text: 'Sync',
                        icon: 'el-icon-refresh',
                        type: '',
                        disabled: false
                    },
                    description: 'Synchronize Data Device and Sensor only from DCE (Historical Data is Not Included)',
                },
                {
                    text: 'DCO Data',
                    url: '/_PopulateMaster/SingleDCOPull',
                    color:
                        'bg-gradient-to-r from-red-800 to-red-600 text-white rounded-lg',
                    setDate: false,
                    buttonAttr: {
                        text: 'Sync',
                        icon: 'el-icon-refresh',
                        type: '',
                        disabled: false
                    },
                    description: 'Synchronize all Asset and its Customer Ownership (Rack, Cage, and USpace) from DCO',
                },
                {
                    text: 'Historical Sensor Data',
                    url: '/MasterHistorical/UpdateHistoricalDataRangeDate',
                    color:
                        'bg-gradient-to-r from-yellow-600 to-yellow-800 text-white rounded-lg col-span-1 xl:col-span-2',
                    setDate: true,
                    dateRange: null,
                    buttonAttr: {
                        text: 'Sync',
                        icon: 'el-icon-refresh',
                        type: '',
                        disabled: false
                    },
                    description: 'Retrieve historical data from all Sensor used in Formula, within specified period',
                }
            ]
        }
    },
    methods: {
        async doSync(item) {
            // start sync process
            item.buttonAttr = {
                text: 'Please wait ...',
                icon: 'el-icon-loading',
                type: 'warning',
                disabled: true
            }

            this.$notify.info({
                title: `Sync ${item.text}`,
                message: `This may take a few moments.`,
                type: 'success'
            })

            var data = {}
            if (item.setDate) {
                data.params = {
                startDate: item.dateRange[0].toISOString().slice(0, 10),
                endDate: item.dateRange[1].toISOString().slice(0, 10)
                }
            }

            // fetching data
            await this.fetchData(item, data)
        },
        async fetchData(item, data = {}) {
            try {
                const res = await this.$axios
                .get(item.url, data)
                .then(() => {
                    this.$notify({
                    title: 'Sync Complete',
                    message: `Data has been Synced successfully`,
                    type: 'success',
                    duration: 10000
                    })

                    // end sync process
                    item.buttonAttr = {
                    text: 'Sync Done',
                    icon: 'el-icon-finished',
                    type: 'success',
                    disabled: false
                    }
                })
                .catch((error) => {
                    var response = error.response
                    var message = 'System Error. Please contact the administrator'

                    if (response.status !== 500) {
                    message = response.data.message
                    }

                    // end sync process
                    item.buttonAttr = {
                    text: 're-sync Data',
                    icon: 'el-icon-finished',
                    type: 'success',
                    disabled: false
                    }

                    this.$notify({
                    title: 'Sync Failed',
                    message: message,
                    type: 'error',
                    duration: 10000
                    })
                    throw message
                })
            } catch (e) {
                console.log(e)
            }
        }
    }
}
</script>